import React from 'react';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import { EntryMethod } from 'src/common/enumerations/entry-method';
import ProductCodeContainer from '../../common/components/code-container/components/product-code-container';
import { setHomePage } from '../../common/components/emerald-home-page/emerald-home-page';
import { IItemLookup } from '../../common/interfaces/dtos/IItemLookup';
import { AppState } from '../../common/redux/configure-store';
import { ScannedDataHandler } from '../../devices/scanner-operations';
import PriceCheckScanWindow from './price-check-scanning-window';
import PriceCheckSellingWindow from './price-check-selling-window';

type Props = IPriceCheckProps;

export const showPriceCheckContainer = (props: Props, onScan: ScannedDataHandler): void => {
  setHomePage(<PriceCheckContainer {...props} />, onScan, { enablePluMenu: true });
};

export const PriceCheckContainer: React.FC<Props> = (props: Props): JSX.Element => {
  const { t } = useTranslation();
  return (
    <ProductCodeContainer
      headerTitle={t('PriceQueryCommand')}
      onKeypadSubmit={props.onKeypadSubmit}
    >
      <PriceCheckChildren {...props} />
    </ProductCodeContainer>
  );
};

const PriceCheckChildren: React.FC<Props> = (props: Props): JSX.Element => {
  const hasQueriedItem = useSelector((state: AppState): boolean => !!state.priceCheck.itemLookup);

  return (
    <>
      {!hasQueriedItem ? (
        <PriceCheckScanWindow onCancel={props.onCancel} />
      ) : (
        <PriceCheckSellingWindow onSell={props.onSell} onCancel={props.onCancel} />
      )}
    </>
  );
};

export interface IPriceCheckProps {
  onSell: (
    itemLookup: IItemLookup,
    quantity: number,
    isManualWeight?: boolean,
    entryMethod?: EntryMethod,
    itemCode?: string,
  ) => Promise<void>;
  onCancel: () => void;
  onKeypadSubmit: (itemId: string) => void;
}
